import flatpickr from 'flatpickr/dist/flatpickr';
import Component from '../abstracts/Component';
import { gregorian } from '@pacote/computus';

/**
 Date picker component
 */
export default class DatePickerComponent extends Component {

  get SELECTORS() {
    return {
      datepicker: '.js-datepicker',
      returnOrderProceed: '.js-proceed-to-confirm',
      dateOfBirth: '.js-dateofbirth',
      modalDatepickers: '.vex-content .js-datepicker'
    }
  }

  shortHandDateFormatByCountry() {
    let currentCountry = document.body.dataset.website;
    let dateFormat = '';

    switch (currentCountry) {
      case 'it':
        dateFormat = "d-m-Y";
        break;
      case 'us':
        dateFormat = "m-d-Y";
        break;
      case 'ko':
        dateFormat = "Y-m-d";
        break;
      default:
        dateFormat = "d-m-Y";
    }

    return dateFormat
  }

  longhandDateFormatByCountry() {
    // Korea: Y-M-D , US : M-D-Y, EU: D-M-Y
    let currentCountry = document.body.dataset.website;
    let dateFormat = '';

    switch (currentCountry) {
      case 'it':
        dateFormat = "d, F Y";
        break;
      case 'us':
        dateFormat = "m-d-Y";
        break;
      default:
        dateFormat = "d, F Y";
    }

    return dateFormat
  }

  today() {
    let todayTime = new Date();
    let dd = todayTime.getDate();
    let mm = todayTime.getMonth() + 1;
    let yyyy = todayTime.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    let format = this.dateFormatByCountry()
    let today = '';

    switch (format) {
      case 'd-m-Y':
        today = dd + '/' + mm + '/' + yyyy;
        break;
      case 'm-d-Y':
        today = mm + '/' + dd + '/' + yyyy;
        break;
      case 'Y-m-d':
        today = yyyy + '/' + mm + '/' + dd;
        break;
      default:
        today = dd + '/' + mm + '/' + yyyy;
    }

    return today
  }

  initDatepicker($dateInputs) {
    $dateInputs = $dateInputs && $dateInputs.length > 0 ? $dateInputs : $(this.SELECTORS.datepicker);

    let ctx = this;
    let _dateFormat = $(ctx.SELECTORS.dateOfBirth).length ? ctx.shortHandDateFormatByCountry() : ctx.longhandDateFormatByCountry();

    $dateInputs.each(function () {
      let _this = $(this);
      let mindate = null;
      let maxdate = null;
      let defaultDate = Date.parse($(this).data('defaultDate'));
      let disableweekends = $(this).data('disableweekends') || false;
      let isAdult = $(this).data('adultValidation')
      let dateFormatCustom = $(this).data('dateFormat');

      mindate = $(this).data('mindate') == 'today' ? 'today' : Date.parse($(this).data('mindate'));
      maxdate = Date.parse($(this).data('maxdate'));


      let forceOneLetterWeekday = function (dateObj, dateStr, instance) {
        $(instance.calendarContainer).find('.flatpickr-weekday').each(function () {
          var weekday = $(this).text().trim();
          if (weekday.length > 0) {
            $(this).text(weekday.charAt(0))
          }
        });
      };

      let forceCalendarOnRight = function (selectedDates, dateStr, instance) {
        setTimeout(() => { // wait after flatpickr calculation
          var inputWidth = $(instance.input).siblings().filter('.js-datepicker')[0].offsetWidth;
          var calendarWidth = instance.calendarContainer.offsetWidth;
          var distanceToRight = inputWidth - calendarWidth;
          instance.calendarContainer.style.left = parseInt(instance.calendarContainer.style.left) + distanceToRight + 1 + 'px';

          if ($(instance.calendarContainer).hasClass("arrowBottom")) {
            instance.calendarContainer.style.top = parseInt(instance.calendarContainer.style.top) + 26 + 'px';
          }
        }, 0);
      };

      let onOpenAddActiveClass = function (dateObj, dateStr, instance) {
        $(instance.input).parents(".date-wrapper").addClass("active");
      };

      let onCloseRemoveActiveClass = function (dateObj, dateStr, instance) {
        $(instance.input).parents(".date-wrapper").removeClass("active");
      };

      let makeTextGlow = function (dateObj, dateStr, instance) {
        let $input = $(instance.input).siblings().filter('.js-datepicker');
        $input.addClass("changed");
        setTimeout(function () {
          $input.removeClass('changed');
        }, 500);
      };

      if (disableweekends) {

        var isGLSOrder = document.getElementById("isGLSOrder");
        var country = $("body").data("website");
        var isCountryIT = country != null && country.toLowerCase() === 'it';
        if ((typeof(isGLSOrder) != 'undefined' && isGLSOrder != null && isGLSOrder.value === 'true') || isCountryIT) {
          var currentEasterDate = gregorian(new Date().getFullYear());
          var currentEasterMondayDate = new Date(currentEasterDate);
          currentEasterMondayDate.setDate(currentEasterDate.getDate() + 1);
          var currentEasterMonday = (currentEasterMondayDate.getDate()) + '/' + (currentEasterMondayDate.getMonth() + 1);
        }

        _this.flatpickr({
          static: false,
          dateFormat: dateFormatCustom == null ? 'Y-m-d' : dateFormatCustom,//output format
          altInput: true,
          altFormat: _dateFormat,//display format
          altInputClass: 'custom-date',
          minDate: mindate,
          maxDate: maxdate,
          disableMobile: true,
          allowInput: true,

          onChange: function (dateObj, dateStr, instance) {
            if ($('input[name=hourpick]').is(":checked")) {
              $(ctx.SELECTORS.returnOrderProceed).removeClass('disabled');
            }
          },
          animate: false,
          disable: [
            function (date) {
              var exclude = ["1/1", "6/1", "25/4", "1/5", "2/6", "15/8", "1/11", "8/12", "25/12", "26/12", currentEasterMonday];
              var d = date.getDate();
              var m = date.getMonth();
              var dayExclude = d + '/' + (m + 1);
              return (date.getDay() === 6 || date.getDay() === 0 || ~$.inArray(dayExclude, exclude));
            }
          ],
          locale: ctx.localization,
          onReady: forceOneLetterWeekday,
          onPreCalendarPosition: forceCalendarOnRight,
          onOpen: onOpenAddActiveClass,
          onClose: onCloseRemoveActiveClass,
          onChange: makeTextGlow,
        });
        const hourpickSelected = $('#hourpickSelected').val();
        if (hourpickSelected) {
          $('#hourpick').val(hourpickSelected);
        }
      } else {
        _this.flatpickr({
          disableMobile: true,
          altInput: true,
          altFormat: _dateFormat,// display format
          dateFormat: dateFormatCustom == null ? 'Y-m-d' : dateFormatCustom,//output format
          altInputClass: 'custom-date',
          minDate: mindate,
          maxDate: maxdate,
          allowInput: true,
          locale: ctx.localization,
          onReady: forceOneLetterWeekday,
          onPreCalendarPosition: forceCalendarOnRight,
          onOpen: onOpenAddActiveClass,
          onClose: onCloseRemoveActiveClass,
          onChange: makeTextGlow,
          parseDate: function(datestr, format) {
            var regex = /^\d{4}[-]\d{2}[-]\d{2}$/;//xxxx-xx-xx
            if(regex.test(datestr)){//value coming from BE
              return new Date(datestr.substring(0, 4), datestr.substring(5, 7) - 1, datestr.substring(8, 10));
            }
          },
        });
      }
    });
  }

  getLocalization(lang) {
    switch (lang) {
      case "en":
        return "default";
      case "el":
        return "gr";
      default:
        return lang;
    }
  }

  bindEvents() {
    const ctx = this;
    const $dateOfBirth = $(ctx.SELECTORS.dateOfBirth);
    if ($dateOfBirth[1]) {
      $dateOfBirth[1].onkeydown = function(e) {
        return ctx.isNumeric(this, e.key, /* isShift */ false);
      }
      $dateOfBirth[1].onkeyup = function() {
        ctx.validateDateFormat(this);
      }
    }
  }

  bindCustomEvents () {
    this.$on(this.$customEvents.PAGE_LAYOUT_EVENTS.initDatepicker, () => {
      if (!this.flatpickr) {
        this.loadFlatPickr();
      } else {
        this.initDatepicker();
      }
    });

    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, () => {
      this.initDatepickerWithinModal();
    });

    this.$on(this.$customEvents.MODAL_EVENTS.afterUpdateContent, () => {
      this.initDatepickerWithinModal();
    });
  }

  initDatepickerWithinModal () {
    if ($(this.SELECTORS.modalDatepickers).length > 0) {
      if (!this.flatpickr) {
        this.loadFlatPickr();
      } else {
        this.initDatepicker($(this.SELECTORS.modalDatepickers));
      }
    }
  }

  render() {
    if (document.querySelectorAll(this.SELECTORS.datepicker) || document.querySelector('#returnDate') || document.querySelector('.t-book-appointment')) {
      this.loadFlatPickr();
    }

    this.bindCustomEvents();
  }

  loadFlatPickr () {
    if (this.flatpickr) {
      return;
    }

    const lang = this.getLocalization($('html').attr('lang'))
    this.moduleLoader.loadFlatpickr(
      (module) => {
        this.moduleLoader.loadFlatpickrLocale(lang, (localization) => {
            this.flatpickr = module.default;
            this.localization = lang;
            this.initDatepicker();
            this.bindEvents();
            this.setMaxLengthBirthDatePicker();
          },
          (err) => {
            console.error('cant load flatpickr');
            console.error(err)
          }
        );
      })
  }

  isNumeric(input, keyCode, isShift) {
    let acceptableKeys = ['0','1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'ArrowRight', 'ArrowLeft'];
    isShift = false;
    let seperator = '-'
    if (keyCode == 'ShiftLeft'|| keyCode == 'ShiftRight') {
      isShift = true;
    }
    //Allow only numeric keys
    if (acceptableKeys.includes(keyCode) && isShift == false) {
      if ((input.value.length == 2 || input.value.length == 5) && keyCode != 'Backspace') {
        input.value += seperator;
      }
      return true;
    }
    else {
      return false;
    }
  }

  validateDateFormat(input) {
    let dateString = input.value;
    let _dateFormat = $(this.SELECTORS.dateOfBirth).length ? this.shortHandDateFormatByCountry() : this.longhandDateFormatByCountry();

    let regex = /^\d{2}[-]\d{2}[-]\d{4}$/;
    let formInput = $(this.SELECTORS.datepicker)[0];

    //Check whether valid date format for manual insert.
    if (regex.test(dateString)) {
      //Parsing user manual insert
      let date = flatpickr.parseDate(dateString, this.shortHandDateFormatByCountry());

      //Change calendar view
      formInput._flatpickr.setDate(date);
    }
    //emit 'input' event to trigger other listeners
    formInput.dispatchEvent(new Event('input'));
  }

  setMaxLengthBirthDatePicker() {
    $(this.SELECTORS.dateOfBirth).attr('maxlength', '10');
  }
}
